const url = '/payments-terminals';
const Provider = 'PaymentsTerminals';
const dbModel = 'PaymentsTerminals';

export { url, Provider, dbModel };
